import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultLocale, supportedLocales, languageOptions, localeCookie } from '../constants';
import Cookies from 'js-cookie';

const checkLocale = (locale: string) => {
  if (supportedLocales.includes(locale)) {
    return locale;
  } else {
    const [language] = locale.split('-');
    return languageOptions.find(lng => lng.languageCode === language)?.value;
  }
};

export const buildCustomLanguageDetector = () => {
  const customLanguageDetector = new LanguageDetector();
  customLanguageDetector.addDetector({
    name: 'customDetector',
    lookup(): string | undefined {
      const detectedLanguage =
        new URL(window.location.href).searchParams.get('lng') ||
        Cookies.get(localeCookie) ||
        localStorage.getItem('i18nextLng');
      if (detectedLanguage && checkLocale(detectedLanguage)) {
        return checkLocale(detectedLanguage);
      } else if (navigator.languages.length) {
        for (let locale of navigator.languages) {
          if (checkLocale(locale)) {
            return checkLocale(locale);
          }
        }
      }

      return defaultLocale;
    }
  });

  return customLanguageDetector;
};
